import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { manifesto } from '../mock';

const About = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section id="about" ref={ref} className="relative py-32 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 60 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            關於我們
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Design, Details, Timeless ‧ 源自極致美學、精密工藝與100%透明化承諾
          </p>
        </motion.div>

        {/* Manifesto Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {manifesto.map((item, index) => (
            <motion.div
              key={item.number}
              initial={{ opacity: 0, y: 60 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 60 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className="group relative"
            >
              <div className="absolute -left-4 top-0 text-8xl font-bold text-[#FF6B35]/10 group-hover:text-[#FF6B35]/20 transition-colors duration-500">
                {item.number}
              </div>
              <div className="relative pl-16">
                <h3 className="text-3xl font-bold text-gray-900 mb-3">
                  {item.titleChinese}
                </h3>
                <p className="text-sm text-[#9CAF88] font-medium mb-4">
                  {item.title}
                </p>
                <p className="text-gray-600 leading-relaxed">
                  {item.contentChinese}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Stats Section */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 60 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="mt-32 grid grid-cols-2 md:grid-cols-4 gap-8"
        >
          {[
            { number: '98%', label: '準時交付率', labelEn: 'On-Time Delivery' },
            { number: '95%', label: '零追加達成', labelEn: 'No Extra Charges' },
            { number: '98.8%', label: '零翻工合格', labelEn: 'First-Time Quality' },
            { number: '93%', label: '客戶推薦率', labelEn: 'Referral Rate' },
          ].map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.6, delay: 1 + index * 0.1 }}
              className="text-center"
            >
              <div className="text-5xl md:text-6xl font-bold text-[#FF6B35] mb-2">
                {stat.number}
              </div>
              <div className="text-gray-900 font-medium">{stat.label}</div>
              <div className="text-sm text-[#9CAF88]">{stat.labelEn}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default About;
